import { ActionSheetContext, Icon, ListDescription, ListItem } from '@alto/design-system';
import React, { useContext } from 'react';
import { useCartSelectedPricingInfoForPrescription } from '~shared/features/prescriptions/hooks/useCartSelectedPricingInfoForPrescription';
import { getInsuranceName } from '~shared/helpers/insuranceName';
import { useGetInsuranceByID } from '~shared/queries/query-keys/insurances';
import { SelectPriceOptionActionSheet } from '../../../index';

type PriceOptionChangeListItemProps = {
  readonly prescriptionID: number;
  readonly handleClose: () => void;
};

export const PriceOptionChangeListItem = ({ prescriptionID, handleClose }: PriceOptionChangeListItemProps) => {
  const { setActiveActionSheet } = useContext(ActionSheetContext);
  const { prescriptionPricingInfo, priceOptions } = useCartSelectedPricingInfoForPrescription({ prescriptionID });
  const { price, paymentType } = prescriptionPricingInfo || {};
  const withInsuranceOption = priceOptions.find((option) => option.type === 'with_insurance');
  const { insurance } = useGetInsuranceByID(withInsuranceOption?.insurance_id);

  let priceDescription = price || 'Price Unavailable';

  if (paymentType === 'without_insurance') {
    priceDescription += ', Paying without insurance';
  } else if (insurance) {
    const { primaryName } = getInsuranceName(insurance);
    priceDescription += `, ${primaryName}`;
  }

  const onPress = () => {
    setActiveActionSheet(<SelectPriceOptionActionSheet handleClose={handleClose} />);
  };

  return (
    <ListItem
      title="Price"
      LeftContent={<Icon name="pricetag" />}
      RightContent={<Icon name="chevronright" />}
      descriptions={<ListDescription>{priceDescription}</ListDescription>}
      onPress={onPress}
    />
  );
};
